import { useMeasurements } from "hooks/useMeasurements";
import { useProducts } from "hooks/useProducts";
import { reportStepMetadata } from "util/reportStepMetadata";
import { ChemicalsWithMeasurementsTable } from "./ChemicalsWithMeasurementsTable";
import { FacilityChemicalsTable } from "./FacilityChemicalsTable";
import { StepperPageHeader } from "./Report/StepperPageHeader";

export type ChemicalsTableProps = {
  facilityId: string;
  reportId?: string;
};

export function ChemicalsTable(props: ChemicalsTableProps) {
  const { hasMeasurements } = useMeasurements(props.facilityId);
  const { hasProducts: isOtherChemicals } = useProducts();

  const step = isOtherChemicals
    ? reportStepMetadata.OTHER_CHEMICALS
    : reportStepMetadata.CHEMICALS;

  const header = step.title;
  const headerDescription = step.getOverviewDescription({
    hasProducts: isOtherChemicals,
  });

  let table;
  if (hasMeasurements) {
    table = <ChemicalsWithMeasurementsTable {...props} />;
  } else {
    table = <FacilityChemicalsTable {...props} />;
  }

  return (
    <>
      <StepperPageHeader header={header} description={headerDescription} />
      {table}
    </>
  );
}
